import React, { useContext, useEffect } from 'react'
import { Alert } from 'components'
import { Form } from 'components/Form'
import { alerts as alertKeys } from 'keys'
import { WrapTestTakerForm } from './Style'
import { useSelector } from 'react-redux'
import { testTakerHooks, validate } from 'pages/School/CreateTestTakers'
import { CreateTestTakersContext } from './CreateTestTakerContext'

const CreateTestTakers = () => {
    const { alerts } = useSelector(state => state.general)
    const { errorList } = useContext(CreateTestTakersContext)

    const fields = testTakerHooks.useFormFields()
    const submitBtns = testTakerHooks.useSubmitBtns()
    const setAlert = testTakerHooks.useAlert()
    const cleanData = testTakerHooks.useCleanData()

    useEffect(() => {
        return (() => {
            cleanData()
        })
    }, [])

    return (
        <Alert
            title={`פרטי הכיתה`}
            footerActions={submitBtns}
            handleAlert={() => setAlert(false)}
        >
            <WrapTestTakerForm>
                <Form
                    form={"test_takers"}
                    validations={validate}
                    fields={fields}
                    submit={() => { }}
                    initialValues={alerts[alertKeys.createTestTaker]?.props}
                />
                <div className='wrap-error-list'>
                    {errorList.map((err) =>
                        <div>{err}</div>
                    )}
                </div>
            </WrapTestTakerForm>
        </Alert>
    )
}

export default CreateTestTakers